import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { AlertCircle, ArrowLeft } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-start sm:items-center justify-center px-4 py-8 overflow-y-auto" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A3A3A3] hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <div className="bg-[#141414] border border-[#262626] p-8">
          <div className="mb-8">
            <p className="overline text-[#FF3B30] mb-2">ADMIN ACCESS</p>
            <h1 className="font-cabinet text-3xl font-black uppercase tracking-tighter">
              LOGIN
            </h1>
          </div>

          {error && (
            <div className="flex items-center gap-2 bg-[#FF3B30]/10 border border-[#FF3B30] p-3 mb-6" data-testid="login-error">
              <AlertCircle className="w-5 h-5 text-[#FF3B30] flex-shrink-0" />
              <p className="text-[#FF3B30] text-sm">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="overline">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-[#0A0A0A] border-[#262626] focus:border-[#FF3B30] rounded-none h-12 text-white"
                placeholder="admin@melodrop.com"
                required
                data-testid="login-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="overline">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-[#0A0A0A] border-[#262626] focus:border-[#FF3B30] rounded-none h-12 text-white"
                placeholder="••••••••"
                required
                data-testid="login-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#FF3B30] hover:bg-white hover:text-[#0A0A0A] rounded-none h-12"
              data-testid="login-submit-btn"
            >
              {loading ? 'LOGGING IN...' : 'LOGIN'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
